import { isPrivateBookingPage } from '#shared/entry-points';

export default defineNuxtRouteMiddleware((to) => {
  const routeBaseName = useRouteBaseName();
  const name = routeBaseName(to);
  // The token lives in memory only: a reload, a bookmark or a typed URL lands here without one.
  if (typeof name !== 'string' || !isPrivateBookingPage(name) || useBookingAccessStore().bookingAccess) {
    return;
  }

  const localePath = useLocalePath();
  return navigateTo(localePath('my-booking-login'), { redirectCode: 302 });
});
